import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import HotspotComponent from "./hotspot-component.vue";
import { HotspotStateProtobufSerializer } from "./hotspot-state-protobuf-serializer";
import { IncludeHotspotHandler } from './include-hotspot-handler';

export const hotspotFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(HotspotComponent)
    .whenTargetNamed("hotspot");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeHotspotHandler);

  bind(SerializationApi.StateSerializationPluginSymbol).to(HotspotStateProtobufSerializer)
});
